<template>
    <div class="mb-6">
        <base-hint name="landlords-transactions-index">
            <template slot="heading">
                Payments
            </template>

            <p class="mb-3">
                See all of your payments here, just like a bank statement.
            </p>

            <p>
                At a glance you can also see important information associated with each payment, for example, the payer, tenancy and property.
            </p>
        </base-hint>

        <balance-card />

        <transactions-card />
    </div>
</template>

<script>
    import BalanceCard from './index/balance-card'
    import TransactionsCard from './index/transactions-card'

    export default {
        components: {
            BalanceCard,
            TransactionsCard
        }
    }
</script>
